var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list-item', {
    on: {
      "click": function click($event) {}
    }
  }, [_c('v-list-item-avatar', {
    attrs: {
      "size": _vm.$size()
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.credit.icon
    }
  })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.credit.name))])], 1), _vm.credit.gitlab ? _c('v-list-item-action', {
    staticClass: "ml-2 my-1"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "href": _vm.credit.gitlab,
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v("mdi-gitlab")])], 1)], 1) : _vm._e(), _vm.credit.qq ? _c('v-list-item-action', {
    staticClass: "ml-2 my-1"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "href": _vm.credit.qq,
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v("mdi-qqchat")])], 1)], 1) : _vm._e(), _vm.credit.twitter ? _c('v-list-item-action', {
    staticClass: "ml-2 my-1"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "href": _vm.credit.twitter,
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v("mdi-twitter")])], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }